import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_PM_CATEGORY_PERFORMANCE_API } from "./apiRoutes";

interface Props {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCategoryPerformance = async (projectId: string) => {
  return await axiosAuth.get(`${DASHBOARD_PM_CATEGORY_PERFORMANCE_API(projectId)}`);
};

const useGetPmCategoryPerformance = ({ projectId, queryParams }: Props): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-category-performance", projectId],
    queryFn: () => getCategoryPerformance(projectId),
    select: (data: any) => data.data.data,
    refetchOnWindowFocus: false,
    enabled: !!projectId,
    ...queryParams,
  });
};

export default useGetPmCategoryPerformance;
